import React, { useCallback, useEffect, useState } from "react";
import { Card, Table, Spinner, Button } from "react-bootstrap";
import api, { BASE_URL } from "../../../Utils/api";
import { useFeedback } from "../Feedback/FeedbackContext";


function formatarDataHora(value) {
  if (!value) return "—";
  const d = new Date(value);
  return d.toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function TokensAtivos() {
  const { toast, confirm } = useFeedback();
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [invalidando, setInvalidando] = useState(null);

  const carregar = useCallback(() => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    fetch(`${BASE_URL}/api/godmode/usuariosAcessoRecente`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        if (!res.ok) throw new Error(res.status === 403 ? "Acesso restrito a Super Admin." : "Erro ao carregar.");
        return res.json();
      })
      .then((data) => setUsuarios(Array.isArray(data?.usuarios) ? data.usuarios : []))
      .catch((err) => {
        setError(err.message || "Erro ao carregar tokens ativos.");
        setUsuarios([]);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    carregar();
  }, [carregar]);

  const currentUserId = Number(localStorage.getItem("user_id")) || null;

  const handleInvalidar = async (userId, nome) => {
    const ehVoce = currentUserId !== null && Number(userId) === currentUserId;
    const msg = ehVoce
      ? "Invalidar seu próprio acesso? Você será deslogado e precisará fazer login novamente."
      : `Encerrar o acesso do usuário "${nome || userId}"? Ele precisará fazer login novamente.`;
    const ok = await confirm(msg);
    if (!ok) return;

    setInvalidando(userId);
    const token = localStorage.getItem("authToken");
    api
      .post(`${BASE_URL}/api/godmode/invalidarAcesso/${userId}`, {}, { headers: { Authorization: `Bearer ${token}` } })
      .then(() => {
        if (currentUserId !== null && Number(userId) === currentUserId) {
          localStorage.removeItem("authToken");
          window.location.replace(`${window.location.origin}/login`);
          return;
        }
        setUsuarios((prev) => prev.filter((u) => u.id !== userId));
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Erro ao invalidar acesso.");
      })
      .finally(() => setInvalidando(null));
  };

  if (loading) {
    return (
      <Card>
        <Card.Header className="fw-semibold">Tokens ativos (acessos nas últimas 2h)</Card.Header>
        <Card.Body className="d-flex justify-content-center py-4">
          <Spinner animation="border" />
        </Card.Body>
      </Card>
    );
  }

  if (error) {
    return (
      <Card className="border-warning">
        <Card.Header className="fw-semibold">Tokens ativos (acessos nas últimas 2h)</Card.Header>
        <Card.Body className="text-warning">{error}</Card.Body>
      </Card>
    );
  }

  return (
    <Card>
      <Card.Header className="fw-semibold">
        Tokens ativos (acessos nas últimas 2h) — {usuarios.length} usuário{usuarios.length !== 1 ? "s" : ""}
      </Card.Header>
      <Card.Body className="p-0">
        {usuarios.length === 0 ? (
          <p className="text-muted p-3 mb-0">Nenhum usuário com acesso nas últimas 2 horas.</p>
        ) : (
          <Table striped bordered hover responsive size="sm" className="mb-0">
            <thead>
              <tr>
                <th>#</th>
                <th>ID</th>
                <th>Nome</th>
                <th>E-mail</th>
                <th>Último acesso</th>
                <th style={{ width: 120 }}>Ação</th>
              </tr>
            </thead>
            <tbody>
              {usuarios.map((u, idx) => (
                <tr key={u.id}>
                  <td>{idx + 1}</td>
                  <td>{u.id}</td>
                  <td>{u.nome ?? "—"}</td>
                  <td>{u.email ?? "—"}</td>
                  <td>{formatarDataHora(u.ultimo_acesso)}</td>
                  <td>
                    <Button
                      size="sm"
                      variant="outline-danger"
                      disabled={invalidando === u.id}
                      onClick={() => handleInvalidar(u.id, u.nome || u.email)}
                    >
                      {invalidando === u.id ? "..." : "Invalidar acesso"}
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Card.Body>
    </Card>
  );
}

export default TokensAtivos;
